export enum KavaClickTypes {
  'Create' = 1,
  'Filter' = 2,
  'Search' = 3,
  'Export' = 4,
  'Navigate' = 5,
  'Schedule' = 6,
  'Insert' = 7,
  'Choose' = 8,
  'Launch' = 9,
  'Open' = 10,
  'Send' = 11,
  'Invite' = 12,
  'Close' = 13,
  'Save' = 14,
  'Expand' = 15,
  'Collapse' = 16,
  'Edit' = 17,
  'Delete' = 18,
  'Browse' = 19,
  'Load' = 20,
  'Add' = 21,
}
